import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Priya Nair",
    role: "CEO, Haven Labs",
    avatar:
      "https://images.unsplash.com/photo-1581841064838-a470c740e8ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBhdmF0YXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzY0OTE4NjF8MA&ixlib=rb-4.1.0&q=85",
    quote:
      "Devzcorner shipped our AI assistant in six weeks, production-grade and polished. Faster than our internal team could even write the spec.",
    rating: 5,
  },
  {
    name: "Arjun Mehta",
    role: "Founder, PrintForge",
    avatar:
      "https://images.pexels.com/photos/36053652/pexels-photo-36053652.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "A rare team that understands software, firmware, and physical manufacturing. The custom enclosure design alone saved us two months of back-and-forth.",
    rating: 5,
  },
  {
    name: "Sara Kapoor",
    role: "Product Lead, NovaFlow",
    avatar:
      "https://images.pexels.com/photos/36645466/pexels-photo-36645466.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote:
      "Working with Devzcorner is like having a senior engineer, a PM, and a product designer in the same person. Zero handoff overhead, pure velocity.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-32"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
            / 07 — Client stories
          </div>
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={{
              visible: { transition: { staggerChildren: 0.1 } },
            }}
            className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            data-testid="testimonials-heading"
          >
            <motion.span 
              variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } } }} 
              className="block"
            >
              Founders who shipped
            </motion.span>
            <motion.span 
              variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } } }} 
              className="block text-zinc-500"
            >
              with Devzcorner.
            </motion.span>
          </motion.h2>
          <p className="mt-6 text-zinc-400 max-w-xl text-lg font-light">
            Don't take our word for it. Here's what the people we've worked with have to say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="bg-ink-50 border border-white/[0.08] rounded-2xl p-5 sm:p-7 md:p-8 hover:border-white/20 transition-all flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star
                    key={idx}
                    size={14}
                    className="fill-accent-cyan text-accent-cyan"
                  />
                ))}
              </div>
              <blockquote className="font-display text-lg md:text-xl leading-snug text-zinc-200 flex-1">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3 pt-5 border-t border-white/5">
                <div>
                  <div className="text-sm font-medium text-white">{t.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                    {t.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
